import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillFlightBookingData', request)
}

export {post}
